export default function InputError({ children }: { children?: string }) {
  return <p className='text-red-600 text-sm mt-1'>{children}</p>;
}
